import React from 'react';
import { useGameContext } from '../contexts/GameContext';
import WheelMode from './WheelMode';
import CardsMode from './CardsMode';
import TaskDisplay from './TaskDisplay';

const GameBoard = ({ gameMode, setGameMode }) => {
  const {
    currentLevel,
    playerDetails,
    currentPlayer,
    roundsPlayed,
    roundsPerLevel,
    selectedTask,
    showTaskText
  } = useGameContext();

  return (
    <div className="game-container">
      <div className="game-info">
        <h2>Level {currentLevel}</h2>
        <p>Current Player: {playerDetails[currentPlayer].name}</p>
        <p>Rounds: {roundsPlayed[currentPlayer] + 1}/{roundsPerLevel}</p>
      </div>

      {gameMode === 'wheel' && !selectedTask && <WheelMode />}
      {gameMode === 'cards' && !showTaskText && <CardsMode />}
      {selectedTask && showTaskText && <TaskDisplay />}

      <button onClick={() => setGameMode(null)} className="back-button">
        Back to Setup
      </button>
    </div>
  );
};

export default GameBoard;
